// extracted by mini-css-extract-plugin
export default {"menu-item":"Menu_menu-item__rz2yr"};